export default {
  data() {
    return {
      highlightedColumnId: null,
    };
  },
  methods: {
    isMagazineColumn(column) {
      return !!(column && column.code && !column.is_group_total);
    },
    isLeafHighlighted(leaf) {
      return !!(leaf && (leaf.highlighted || (this.highlightedColumnId && leaf.id === this.highlightedColumnId)));
    },
    toggleColumnHighlight(column) {
      if (!this.isMagazineColumn(column)) return;
      this.highlightedColumnId = this.highlightedColumnId === column.id ? null : column.id;
    },
    columnHeaderTitle(column) {
      if (!this.isMagazineColumn(column)) return "";
      return this.highlightedColumnId === column.id
        ? "Kliko për të hequr theksimin e kolonës"
        : "Kliko për të theksuar kolonën e magazinës";
    },
  },
};
